<template>
  <div clas="row col-xs-12">
    <div class="row center">
      <div class="col-xs-12 top-bar pv3 middle-xs">
        <div class="tl">
          <pl-button @click.native="goBack" style="margin: 0; padding: 0;">
            <span class="back-btn truncate-text pl-white-font">
              <i class="fa fa-arrow-left"></i>
            </span>
          </pl-button>
        </div>
        <div class="tc admin-portal-title">
          System - Wide Data
        </div>
      </div>
    </div>
    <div class="row scroll-container">
      <!-- Selection Side Nav -->
      <nav class="col-xs-12 col-md-3 col-lg-2 pt4">
        <ul class="menu-sidenav">
          <!-- Removed email from the nav for now, don't think email should be changed -->
          <li v-for="(selected_tab, key) in displayable_tabs"
            v-bind:key="key"
            @click="selected_tab.href ? goToExternalLink(selected_tab.href) : goToTab(selected_tab.routeName)"
            class="row middle-xs h-100"
            style="vertical-align: middle; margin-top: 5px;"
            :class="{ 'selected-tab': is_selected_tab(selected_tab.routeName) }"
          >
            <img
              :src="`/static/${selected_tab.icon}`"
              alt=""
              style="width: 18px; margin-right: 10px;"
            />
            <div>
              {{ selected_tab.title }}
            </div>
          </li>
        </ul>
      </nav>
      <div class="col-xs-12 col-md-9 col-lg-10">
        <transition>
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script lang="babel">
  import { mapGetters } from 'vuex';
  import schoolSockets from 'mixins/sockets/schoolSocketEvents';

   export default {
    data() {
      return {
        school_name: '',
        has_new_suggestions:null,
        users_tabs: ['Analytics', 'Users']
      };
    },
    mixins: [schoolSockets],
    computed: {
      ...mapGetters(['getProfile','getCurrentSchool']),
      displayable_tabs() {
        const tabs = [
          { title:'Analytics', routeName:'admin-portal-parlay-analytics', icon:'bar-chart.svg' },
          { title:'Users', routeName: 'admin-portal-parlay-users', icon:'group.svg' },
        ];
        if (this.getProfile.role !== 'admin' )
          return tabs.filter(tab => this.users_tabs.includes(tab.title));
        return tabs;
      }
    },
    methods: {
      goBack(){
        this.$router.push({name: 'admin-school-management'});
      },
      goToTab(routeName){
        this.$router.push({
          name: routeName,
        });
      },
      goToExternalLink(link){
        window.open(link, '_blank');
      },
      is_selected_tab(tabName) {
        return this.$route.name === tabName;
      },
      getSchoolDetails(){
        this.$store.dispatch('getSchoolDetails',this.$route.params.schoolID).then(() => {
          this.has_new_suggestions = this.getCurrentSchool.has_new_suggestions;
        });
      }
    },
    mounted(){
    },
    beforeDestroy() {
    }
   };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'
  .top-bar
    background-color: pl-primary
  .admin-portal-title
    margin-top: -25px
    color: #ffffff
    font-size: 24px
    font-weight: 600
  .menu-sidenav
    padding: 0
    position: inline-block
    border-radius: 7px
    list-style: none
    margin: 0 0 0 2rem
    overflow-y: scroll
    li
      height: 48px
      margin: 0
      padding-left: 20px
      cursor: pointer
      font-size: 20px
      font-weight: 500
      @media (max-width: 1620px) and (min-width: 1024px)
        font-size: 12px

  .scroll-container
    height: calc(100vh - 63px)
    overflow-y: scroll
    nav
      border-right: 1px solid;

  .profile-content
    padding-left: 19px !important
    height: 100%
    overflow-y: scroll;
  .selected-tab
    font-weight: 600 !important
    background-color: rgba(133, 215, 226, 0.3)
    border-radius: 50px
</style>



// WEBPACK FOOTER //
// adminPortalParlay.vue?63895e81